import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Analytics, AutoAwesome, } from '@mui/icons-material';
import DashboardProvider from '../../components/providers/DashboardProvider';
import ControlSocketProvider from '../../components/providers/ControlSocketProvider';
// import app_icon_design from "../../assets/images/app_icon_design.png"
// import app_icon_ai from "../../assets/images/app_icon_ai.png"


const navItems = [
  {
    text: "EMS Panel",
    route: "/dashboard",
    // icon: <img src={app_icon_design} />,
    icon: <Analytics />
  },
  {
    text: "AI Assistant",
    route: "/ai",
    // icon: <img src={app_icon_ai}/>,
    icon: <AutoAwesome />
  },
]

const RootLayout = () => {


  const [activeTabTitle, setActiveTabTitle] = useState(navItems[0].text);

  const sidebarWidthContracted = "50px";
  const sidebarWidthExpanded = "200px";


  return (
    <Box
      sx={{
        display: 'flex',
        width: "100hw",
        minHeight: "100vh",
        // minWidth: "100hw",
      }}
    >
      {/* Side bar */}
      {/* <Sidebar
        navItems={navItems}
        activeTab={activeTabTitle}
        setActiveTab={setActiveTabTitle}
        widthContracted={sidebarWidthContracted}
        widthExpanded={sidebarWidthExpanded}
      /> */}

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          width: "100hw",
          minHeight: "100vh",
          backgroundColor: "var(--c-bg)",
        }}
      >
        <DashboardProvider>
          <ControlSocketProvider>
            <Outlet />
          </ControlSocketProvider>
        </DashboardProvider>
      </Box>

    </Box >
  );
};

export default RootLayout;